import { LiquidUnit } from "@tandemdiabetes/sugarmate-api-react-client"

import { round } from "./round"

const microlitersPerOz = 29573.5

function roundToStep(
  value: number,
  decimalPlaces = 0,
  step = 1,
) {
  return parseFloat((round(value / step) * step).toFixed(decimalPlaces))
}

/*
 * this function convers ml to liquid unit and currently only uses US units
 *
 * note: a fluid ounce is 29.5735 in the US, an imperial fluid ounce is 28.4131
 * note: a cup is 236.588 ml (8 us fl oz) in the US and 250 ml in Australia, Canada, New Zealand, and the UK, and an imperial cup is 284.131 ml
 * note: a pint is 473.176 ml (16 us fl oz) in the US and an imperial pint is 568 (20 imperial fl oz)
 */
export function liquidMicrolitersToUnit(
  microliters: number,
  unit: LiquidUnit,
): number {
  const ounces = microliters / microlitersPerOz

  switch (unit) {
    case LiquidUnit.Cups:
      return roundToStep(
        ounces / 8,
        2,
        0.01,
      )
    case LiquidUnit.Pints:
      return roundToStep(
        ounces / 16,
        2,
        0.01,
      )
    case LiquidUnit.FluidOunces:
      return roundToStep(
        ounces,
        1,
        0.1,
      )
    case LiquidUnit.Liters:
      return roundToStep(
        microliters / 1000000,
        2,
        0.01,
      )
    case LiquidUnit.Milliliters:
      return roundToStep(
        microliters / 1000,
        0,
        1,
      )
    default:
      return NaN
  }
}
